import React from "react";
import { styled } from "../stitches.config";
import Link from "../components/Link";
import Media from "../components/common/Media";
import useMediaQuery from "../helpers/useMediaQuery";
import RenderSlateChildren from "../components/Article/Parts/Slate/RenderSlateChildren";
import { WideContentElement } from "../components/Article/Parts/Slate/types";

type ExtendedWideContentProps = {
  btnText?: string;
  btnLink?: string;
  title?: string;
  imgUrl?: string;
};

type WideContentProps = {
  element: ExtendedWideContentProps & WideContentElement;
};

const ExtraWideContent: React.FC<WideContentProps> = ({
  element
}) => {
  const isBigDesktop = useMediaQuery('bp5');
  const {
    btnLink,
    btnText,
    title,
    imgUrl,
    children,
  } = element;
  return (
    <StyledWideContent>
      {!isBigDesktop && <Title>{title}</Title>}
      <MediaWrapper>
        <Media
          src={imgUrl}
          //height={400}
          width={isBigDesktop ? 600 : 948}
          disablePreload={true}
        />
      </MediaWrapper>
      <ContentWrapper>
        {isBigDesktop && <Title>{title}</Title>}
        <Text>
          <RenderSlateChildren element={children} />
        </Text>
        <Link to={btnLink}>{btnText}</Link>
      </ContentWrapper>
    </StyledWideContent>
  );
};

const StyledWideContent = styled("div", {
  position: "relative",
  width: "calc(100%)",
  background: "$grayscale100Fixed",
  margin: "20px 0",
  "@bp5": {
    display: "flex",
    width: "calc(100% + 456px)", // 100% + marginy do szerokości 1300px
    left: "-228px",
  },
});

const MediaWrapper = styled("div", {
  flexShrink: 0,
  width: "100%",
  "@bp5": {
    width: "600px",
  },
  img: {
    width: "100%",
    "@bp4": {
      height: "100%",
    },
  }
});

const ContentWrapper = styled("div", {
  background: "$grayscale100Fixed",
  padding: "16px",
  width: "100%",
  "@bp4": {
    padding: "36px 58px"
  },

  "& a": {
    padding: "10px 35px 10px 35px",
    marginTop: "16px",
    fontSize: "16px",
    backgroundColor: "$primary",
    color: "$grayscale0Fixed !important",
    fontWeight: "bold",
    margin: "auto",
    display: "block",
    width: "fit-content",

    "@bp5": {
      display: "inline",
      padding: "15px 35px",
    }
  }
});

const Title = styled("h1", {
  color: "$grayscale0Fixed",
  fontWeight: "bold",
  fontSize: "28px",
  marginBottom: "14px",
  paddingTop: "14px",
  textAlign: "center",
  "@bp5": {
    fontSize: "30px",
    marginBottom: "16px",
    paddingTop: "0px",
  }
});

const Text = styled("p", {
  color: "$grayscale0Fixed",
  fontSize: "16px",
  lineHeight: "28px",
  marginTop: "14px",
  "@bp4": {
    fontSize: "21px",
    lineHeight: "28px",
    marginTop: 0,
  },
  "@bp5": {
    height: "200px",
    overflowY: "auto",
    overflowX: "hidden",
  }
});

export default ExtraWideContent
